<template>
  <header id="header" class="header fixed-top" data-scrollto-offset="0">
    <a href="http://www.globalpsa.com" target="_blank"><img class="globalLogo" v-bind:src="logoGlobal"></a>
    <div class="container-fluid d-flex align-items-center justify-content-between">
      <div class="logoDiv"><router-link to="/" class="d-flex align-items-center me-auto me-lg-0"><img alt="logo" v-bind:src="logoMain"></router-link></div>
      <nav id="navbar" class="navbar">
        <ul>
          <li class="dropdown"> <router-link to="/About#ict"><span>{{ $t('navibar1') }}</span> <i class="bi bi-chevron-down dropdown-indicator"></i></router-link>
            <ul>
              <li><router-link to="/About#AboutICT"       class="nav-link scrollto">{{ $t('navibar1_1') }}</router-link></li>
              <li><router-link to="/About#AboutPSA"       class="nav-link scrollto">{{ $t('navibar1_2') }}</router-link></li>
              <li><router-link to="/About#AboutVideo"     class="nav-link scrollto">{{ $t('navibar1_3') }}</router-link></li>
              <li><router-link to="/About#AboutCEO"       class="nav-link scrollto">{{ $t('navibar1_4') }}</router-link></li>
              <li><router-link to="/About#AboutHistory"   class="nav-link scrollto">{{ $t('navibar1_5') }}</router-link></li>
              <li><router-link to="/About#AboutCondition" class="nav-link scrollto">{{ $t('navibar1_6') }}</router-link></li>
              <li><router-link to="/About#AboutCode"   class="nav-link scrollto">{{ $t('navibar1_7') }}</router-link></li>
              <li><router-link to="/About#AboutPolicy"    class="nav-link scrollto">{{ $t('navibar1_8') }}</router-link></li>
            </ul>
          </li>
          <li class="dropdown"><router-link to="/Schedule"><span>{{ $t('navibar2') }}</span> <i class="bi bi-chevron-down dropdown-indicator"></i></router-link>
            <ul>
              <li><router-link to="/Schedule"        >{{ $t('navibar2_1') }}</router-link></li>
              <li><router-link to="/EmptyContainer"  >{{ $t('navibar2_2') }}</router-link></li>
              <li><router-link to="/EmptyInTime"     >{{ $t('navibar2_7') }}</router-link></li>
              <li><router-link to="/VesselWorkStatus">{{ $t('navibar2_3') }}</router-link></li>
              <li><router-link to="/YardWorkStatus"  >{{ $t('navibar2_4') }}</router-link></li>
              <li><router-link to="/Container"       >{{ $t('navibar2_5') }}</router-link></li>
              <li><router-link to="/Vessel"          >{{ $t('navibar2_6') }}</router-link></li>
              <li><router-link to="/CopinoSend"      >{{ $t('navibar2_8') }}</router-link></li>
            </ul>
          </li>
          <li class="dropdown"><router-link to="/Notice/SUBJECT"><span>{{ $t('navibar3') }}</span> <i class="bi bi-chevron-down dropdown-indicator"></i></router-link>
            <ul>
              <li><router-link to="/Notice/SUBJECT">{{ $t('navibar3_1') }}</router-link></li>
              <li><router-link to="/Tender/SUBJECT">{{ $t('navibar3_2') }}</router-link></li>
              <li><router-link to="/Recruit/SUBJECT">{{ $t('navibar3_3') }}</router-link></li>
              <li><router-link to="/Reference/SUBJECT">{{ $t('navibar3_4') }}</router-link></li>
              <li><router-link to="/Ethicalmanagement">{{ $t('navibar3_5') }}</router-link></li>
              <li><router-link to="/FAQ">{{ $t('navibar3_7') }}</router-link></li>
              <li><router-link to="/Contact">{{ $t('navibar3_8') }}</router-link></li>
            </ul>
          </li>
          <li><a href="https://service.psa-ict.co.kr">{{ $t('navibar4') }}</a></li>
            <li class="dropdown"><a><i class="bi bi-translate"></i><i class="bi bi-chevron-down dropdown-indicator"></i></a>
            <ul id="dropdownMenu">
                <li><a href="#" @click="changeKorean">Korean</a></li>
                <li><a href="#" @click="changeEnglish">English</a></li>
            </ul>
          </li>
        </ul>
        <i class="bi bi-list mobile-nav-toggle d-none"></i>
      </nav><!-- .navbar -->
  </div>
  </header>
</template>
<script src="@/assets/js/Common/NaviBar.js"></script>

<style scoped>
.globalLogo{
  float: right;
  margin-right: 50px;
}
.logoDiv{
  width: 15%;
}
  .logoDiv img{
    height: auto;
    width: 100%;
    object-fit: cover;
  }
  #dropdownMenu{
    left: -170%;
  }
  .header{
    height: 13%;
  }
  .container-fluid{
    height: 100%;
  }
  /*모바일에서 적용 320 ~ 768 */
@media (max-width: 768px){
  .logoDiv{
  width: 50%;
  }
  .globalLogo{
  float: right;
  margin-right: 70px;
  margin-top: 10px;
  width: 20%;
}
}
/*태블릿에서 적용 768~ 1024 */
@media (min-width:768px) and (max-width: 1024px){
  .logoDiv{
  width: 40%;
  }
  .globalLogo{
  float: right;
  margin-right: 70px;
  margin-top: 10px;
  width: 20%;
}
.header{
    height: 6%;
  }
}
</style>
